import { render, staticRenderFns } from "./search.template?vue&type=template&id=1d53fcf3&lang=pug&"
import script from "./search.client?vue&type=script&lang=ts&"
export * from "./search.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d53fcf3')) {
      api.createRecord('1d53fcf3', component.options)
    } else {
      api.reload('1d53fcf3', component.options)
    }
    module.hot.accept("./search.template?vue&type=template&id=1d53fcf3&lang=pug&", function () {
      api.rerender('1d53fcf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/search/search.component.vue"
export default component.exports